import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import { heroContent } from '../data/mock';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section 
      id="hero" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#020d2a]"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://customer-assets.emergentagent.com/job_tranship-solutions/artifacts/iblp2qe1_4176.jpeg" 
          alt="Installation professionnelle Orion Industrie"
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#020d2a] via-[#020d2a]/95 to-[#020d2a]/90"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-32 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Text Content */}
          <div className="text-white">
            {/* TRÈS GROS LOGO ORION */}
            <div className="mb-12">
              <img 
                src="/orion-logo-footer.png" 
                alt="Orion Industrie" 
                className="h-48 md:h-56 lg:h-64 xl:h-72 w-auto"
              />
            </div>
            
            <div className="inline-block mb-6">
              <span className="bg-[#FF6600]/20 text-[#FF6600] px-4 py-2 rounded-full text-sm font-semibold border border-[#FF6600]/30">
                Soyez les prochains à nous faire confiance
              </span>
            </div>
            
            <p className="text-2xl lg:text-3xl text-orange-400 mb-6 font-semibold leading-tight">
              Votre métier, c'est de réceptionner, produire et expédier.
              <br/>
              Le nôtre, c'est de vous permettre de le faire en toute sécurité.
            </p>
            
            <h1 className="text-4xl lg:text-5xl font-bold mb-6 leading-tight">
              Équipements de quai & Maintenance industrielle
            </h1>
            
            <p className="text-lg text-gray-300 mb-4 leading-relaxed">
              De la réception des matières premières à l'expédition des marchandises, 
              chaque étape de votre activité repose sur des installations fiables et sécurisées.
            </p>
            
            <p className="text-base text-gray-400 mb-8 leading-relaxed">
              ORION INDUSTRIE vous accompagne dans l'équipement et la sécurisation de vos quais 
              de chargement, ainsi que dans la maintenance et la réparation de vos installations industrielles.
              <br/><br/>
              <strong className="text-gray-300">Notre objectif :</strong> protéger vos équipes, préserver vos équipements et contribuer 
              à la continuité de votre activité.
            </p>

            {/* Key Points */}
            <div className="grid sm:grid-cols-2 gap-4 mb-8">
              {['Normes de sécurité', 'Installation rapide', 'Neuf & rénovation', 'SAV réactif', 'Qualité professionnelle'].map((point, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <CheckCircle className="w-5 h-5 text-orange-500 flex-shrink-0" />
                  <span className="text-gray-300">{point}</span>
                </div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={() => scrollToSection('quote')}
                size="lg"
                className="bg-[#FF6600] hover:bg-[#E65A00] text-white text-lg px-8 py-6 group"
              >
                {heroContent.cta}
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button 
                onClick={() => scrollToSection('products')}
                size="lg"
                variant="outline"
                className="border-2 border-gray-400 text-gray-300 hover:bg-white/10 text-lg px-8 py-6"
              >
                {heroContent.ctaSecondary}
              </Button>
            </div>
          </div>

          {/* Right Column - Featured Product Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-orange-500/30 enhanced-product-image">
              <img 
                src="https://customer-assets.emergentagent.com/job_tranship-solutions/artifacts/oytx1a5m_9C82620C-3241-4100-93E2-1CB893EDE6C8.png"
                alt="Niveleur Hydraulique Orion Industrie"
                className="w-full h-auto"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#020d2a] to-transparent p-6">
                <p className="text-white font-bold text-xl">Niveleur Hydraulique</p>
                <p className="text-orange-400 text-sm">Notre produit phare</p>
              </div>
            </div>

            {/* Floating Stats */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-6 max-w-xs hidden lg:block">
              <div className="flex items-center space-x-4">
                <div className="bg-orange-500 rounded-full p-3">
                  <CheckCircle className="w-6 h-6 text-white" />
                </div>
                <div>
                  <p className="font-bold text-slate-900 text-2xl">100%</p>
                  <p className="text-gray-600 text-sm">Installation professionnelle</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <div className="w-6 h-10 border-2 border-gray-400 rounded-full flex justify-center">
            <div className="w-1 h-3 bg-orange-500 rounded-full mt-2"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
